import { TServerErrorResponse, EmailAddress } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const addClientEmail = async (
  clientId: string,
  { email, primary }: { email: string; primary?: boolean },
): Promise<EmailAddress> => {
  try {
    const response = await http.post<EmailAddress>(
      links.client.emails(clientId),
      { email, primary },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateClientEmail = async (
  clientId: string,
  emailId: string,
  { email }: { email: string },
): Promise<EmailAddress> => {
  try {
    const response = await http.patch<EmailAddress>(
      links.client.emailById(clientId, emailId),
      { email },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteClientEmail = async (
  clientId: string,
  emailId: string,
): Promise<void> => {
  try {
    await http.delete(links.client.emailById(clientId, emailId));
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const setPrimaryClientEmail = async (
  clientId: string,
  emailId: string,
): Promise<EmailAddress> => {
  try {
    const response = await http.patch<EmailAddress>(
      links.client.emailSetPrimary(clientId, emailId),
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
